(function () {
  'use strict';

  var lastPayload = null;

  var COPY = {
    fr: {
      offerEyebrow: 'VOTRE CODE PERSONNEL', offerTitle: '−10 % sur votre première routine',
      personalCode: 'Usage unique · valable 5 jours', copy: 'COPIER', copied: 'COPIÉ ✓', expiresAt: 'Expire le {date} à {time}',
      educationEyebrow: 'DE L’INTÉRIEUR À L’EXTÉRIEUR', educationTitle: 'Pourquoi des compléments alimentaires ?',
      educationIntro: 'Votre peau se voit à l’extérieur, mais elle se construit aussi avec ce que le corps reçoit. Les compléments ne remplacent ni une alimentation variée ni vos soins : ils ajoutent un soutien ciblé à la routine recommandée.',
      educationItems: [
        ['La peau se construit aussi de l’intérieur.', 'Une alimentation variée reste la base. Des compléments peuvent apporter des nutriments et actifs ciblés selon votre profil.'],
        ['Le soin et les compléments n’agissent pas au même endroit.', 'Le soin accompagne la peau en surface ; les compléments complètent l’approche depuis l’intérieur.'],
        ['La régularité compte plus qu’un effet immédiat.', 'Cette approche s’inscrit dans le temps : l’objectif est une routine cohérente et régulière, pas une promesse instantanée.']
      ]
    },
    en: {
      offerEyebrow: 'YOUR PERSONAL CODE', offerTitle: '−10% on your first routine',
      personalCode: 'Single use · valid for 5 days', copy: 'COPY', copied: 'COPIED ✓', expiresAt: 'Expires {date} at {time}',
      educationEyebrow: 'FROM THE INSIDE OUT', educationTitle: 'Why food supplements?',
      educationIntro: 'Your skin is visible on the outside, but it is also built with what your body receives. Food supplements do not replace a varied diet or your skincare: they add targeted support to the routine recommended for you.',
      educationItems: [
        ['Skin is also built from within.', 'A varied diet remains the foundation. Supplements can provide targeted nutrients and active ingredients according to your profile.'],
        ['Skincare and supplements do not work in the same place.', 'Skincare supports the skin from the outside; supplements complement the approach from within.'],
        ['Consistency matters more than an instant effect.', 'This approach works over time: the goal is a coherent, regular routine rather than an overnight promise.']
      ]
    },
    es: {
      offerEyebrow: 'TU CÓDIGO PERSONAL', offerTitle: '−10 % en tu primera rutina',
      personalCode: 'Un solo uso · válido durante 5 días', copy: 'COPIAR', copied: 'COPIADO ✓', expiresAt: 'Caduca el {date} a las {time}',
      educationEyebrow: 'DE DENTRO HACIA FUERA', educationTitle: '¿Por qué complementos alimenticios?',
      educationIntro: 'Tu piel se ve por fuera, pero también se construye con lo que recibe el cuerpo. Los complementos no sustituyen una alimentación variada ni tus cuidados: aportan un apoyo específico a la rutina recomendada.',
      educationItems: [
        ['La piel también se construye desde el interior.', 'Una alimentación variada sigue siendo la base. Los complementos pueden aportar nutrientes y activos específicos según tu perfil.'],
        ['Los cuidados y los complementos no actúan en el mismo lugar.', 'El cuidado acompaña la piel desde el exterior; los complementos completan el enfoque desde el interior.'],
        ['La constancia importa más que un efecto inmediato.', 'Este enfoque se construye con el tiempo: el objetivo es una rutina coherente y regular, no una promesa instantánea.']
      ]
    }
  };

  function qs() { return new URLSearchParams(window.location.search); }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
  function langOf(p) { var l = String((p && p.locale) || 'fr').slice(0,2).toLowerCase(); return COPY[l] ? l : 'fr'; }
  function apiBase() { var s = document.getElementById('ma-routine'); return String((s && s.getAttribute('data-api')) || 'https://diagnostic.eclobeauty.com').replace(/\/$/, ''); }

  function readConfig() {
    var node = document.getElementById('eclo-results-vnext-config');
    if (!node) return { placement: 'after_products', analysis: {}, blocks: [] };
    try { return JSON.parse(node.textContent || '{}'); }
    catch (e) { console.warn('[ECLO VNext] Invalid editor config:', e.message); return { placement: 'after_products', analysis: {}, blocks: [] }; }
  }

  function moduleFlag(payload, key) {
    var modules = payload && payload.result_ui && payload.result_ui.modules;
    if (!modules || modules[key] == null) return false;
    var value = modules[key];
    if (typeof value === 'object') return value.enabled === true;
    return value === true;
  }

  function isVNext(payload) {
    var p = qs();
    if (p.get('ui') === 'current') return false;
    return true;
  }

  function supplementsOf(payload) {
    var r = payload && payload.recommendation ? payload.recommendation : {};
    if (r.products && Array.isArray(r.products.supplements)) return r.products.supplements;
    return Array.isArray(r.supplements) ? r.supplements : [];
  }

  function couponOf(payload, debug) {
    var code = payload && payload.diag_coupon_code;
    var expiry = payload && payload.diag_coupon_expires_at;
    if (!code && debug) {
      code = 'ECLO-DEMO10';
      var d = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000);
      expiry = d.toISOString();
    }
    if (!code) return null;
    var date = expiry ? new Date(expiry) : null;
    if (date && !isNaN(date.getTime()) && date.getTime() <= Date.now()) return null;
    return { code: String(code), expiresAt: date && !isNaN(date.getTime()) ? date : null };
  }

  function couponTimezone(payload) { return String((payload && payload.diag_coupon_timezone) || 'Europe/Paris'); }

  function formatExpiry(date, lang, timeZone) {
    if (!date) return { date: '', time: '' };
    var locale = lang === 'en' ? 'en-GB' : (lang === 'es' ? 'es-ES' : 'fr-FR');
    try {
      var parts = new Intl.DateTimeFormat(locale, {
        timeZone: timeZone, day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(date);
      var byType = {};
      parts.forEach(function (part) { if (part.type !== 'literal') byType[part.type] = part.value; });
      return {
        date: [byType.day, byType.month, byType.year].filter(Boolean).join('/'),
        time: (byType.hour || '00') + (lang === 'fr' ? 'h' : ':') + (byType.minute || '00')
      };
    } catch (e) { return { date: '', time: '' }; }
  }

  function parseItems(value, fallback) {
    var rows = String(value || '').split(/\r?\n/).map(function (row) { return row.trim(); }).filter(Boolean);
    var parsed = rows.map(function (row) {
      var split = row.split('||');
      return [String(split.shift() || '').trim(), String(split.join('||') || '').trim()];
    }).filter(function (item) { return item[0] || item[1]; });
    return parsed.length ? parsed.slice(0, 3) : fallback;
  }

  function languageSetting(settings, lang, suffix, fallback) {
    var key = lang + suffix;
    return settings && settings[key] != null && String(settings[key]).trim() ? String(settings[key]).trim() : fallback;
  }

  function educationCopy(block, lang) {
    var base = COPY[lang];
    var s = block && block.settings ? block.settings : {};
    return {
      eyebrow: languageSetting(s, lang, 'Eyebrow', base.educationEyebrow),
      title: languageSetting(s, lang, 'Title', base.educationTitle),
      intro: languageSetting(s, lang, 'Intro', base.educationIntro),
      items: parseItems(s[lang + 'Items'], base.educationItems)
    };
  }

  function couponCopy(block, lang) {
    var base = COPY[lang];
    var s = block && block.settings ? block.settings : {};
    return {
      eyebrow: languageSetting(s, lang, 'Eyebrow', base.offerEyebrow),
      title: languageSetting(s, lang, 'Title', base.offerTitle),
      meta: languageSetting(s, lang, 'Meta', base.personalCode),
      copy: base.copy,
      copied: base.copied,
      expiresAt: base.expiresAt
    };
  }

  function setVars(el, vars) {
    Object.keys(vars || {}).forEach(function (name) {
      var value = vars[name];
      if (value != null && value !== '') el.style.setProperty(name, String(value));
    });
  }

  function educationElement(block, lang) {
    var c = educationCopy(block, lang);
    var s = block.settings || {};
    var el = document.createElement('section');
    el.className = 'mr-vnext-education mr-vnext-education--' + esc(s.style || 'tint') + ' mr-vnext-title--' + esc(s.titleSize || 'standard');
    el.setAttribute('data-mr-vnext-module', 'supplements_education');
    setVars(el, { '--mr-module-bg': s.background, '--mr-module-text': s.textColor, '--mr-module-accent': s.accent });
    el.innerHTML = '<p class="mr-vnext-eyebrow mono">' + esc(c.eyebrow) + '</p>' +
      '<h3>' + esc(c.title) + '</h3>' +
      '<p class="mr-vnext-education-intro">' + esc(c.intro) + '</p>' +
      '<div class="mr-vnext-education-grid">' +
        c.items.map(function (item, i) {
          return '<article class="mr-vnext-education-item"><span class="mr-vnext-index mono">0' + (i + 1) + '</span><div><strong>' + esc(item[0]) + '</strong><p>' + esc(item[1]) + '</p></div></article>';
        }).join('') +
      '</div>';
    return el;
  }

  function couponElement(block, coupon, lang, timeZone) {
    var c = couponCopy(block, lang);
    var s = block.settings || {};
    var exp = formatExpiry(coupon.expiresAt, lang, timeZone);
    var expiryText = coupon.expiresAt && exp.date ? c.expiresAt.replace('{date}', exp.date).replace('{time}', exp.time) : '';
    var el = document.createElement('section');
    el.className = 'mr-vnext-offer mr-vnext-offer--' + esc(s.style || 'minimal') + ' mr-vnext-title--' + esc(s.titleSize || 'standard');
    el.setAttribute('data-mr-vnext-module', 'coupon');
    setVars(el, { '--mr-module-bg': s.background, '--mr-module-text': s.textColor, '--mr-module-accent': s.accent });
    el.innerHTML = '' +
      '<div class="mr-vnext-offer-main">' +
        '<p class="mr-vnext-eyebrow mono">' + esc(c.eyebrow) + '</p>' +
        '<h3 class="mr-vnext-offer-title">' + esc(c.title) + '</h3>' +
      '</div>' +
      '<div class="mr-vnext-offer-code">' +
        '<p class="mr-vnext-code-label mono">' + esc(c.meta) + '</p>' +
        '<div class="mr-vnext-code-row"><code data-mr-vnext-code>' + esc(coupon.code) + '</code><button type="button" class="mr-vnext-copy mono" data-mr-vnext-copy>' + esc(c.copy) + '</button></div>' +
        (expiryText ? '<p class="mr-vnext-offer-expiry">' + esc(expiryText) + '</p>' : '') +
      '</div>';
    wireCoupon(el, lang);
    return el;
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return Promise.reject(new Error('clipboard unavailable'));
  }

  function wireCoupon(scope, lang) {
    var btn = scope.querySelector('[data-mr-vnext-copy]');
    var code = scope.querySelector('[data-mr-vnext-code]');
    if (!btn || !code) return;
    var c = COPY[lang];
    btn.addEventListener('click', function () {
      copyText(code.textContent.trim()).then(function () {
        btn.textContent = c.copied;
        setTimeout(function () { btn.textContent = c.copy; }, 1500);
      }).catch(function () { window.prompt(c.copy + ' :', code.textContent.trim()); });
    });
  }

  function applyAnalysisConfig(config) {
    var shell = document.getElementById('ma-routine');
    if (!shell) return;
    var analysis = config && config.analysis ? config.analysis : {};
    shell.setAttribute('data-vnext-analysis-style', analysis.style || 'editorial');
    setVars(shell, {
      '--mr-vnext-card-bg': analysis.cardBg || '#FFFFFF',
      '--mr-vnext-soft-bg': analysis.softBg || '#F0ECEF',
      '--mr-vnext-border': analysis.border || '#D8D0C8',
      '--mr-vnext-a1': analysis.accent1 || '#7C846F',
      '--mr-vnext-a2': analysis.accent2 || '#977F96',
      '--mr-vnext-a3': analysis.accent3 || '#A66D4F',
      '--mr-vnext-a4': analysis.accent4 || '#8D7892',
      '--mr-vnext-radius': String(analysis.radius != null ? analysis.radius : 8) + 'px'
    });
  }

  function findRoutineIntro(root) {
    var heading = root.querySelector('.mr-h2');
    if (!heading) return null;
    return heading.nextElementSibling && heading.nextElementSibling.classList.contains('mr-lede') ? heading.nextElementSibling : heading;
  }

  function findPlacementAnchor(root, placement) {
    var intro = findRoutineIntro(root);
    if (!intro) return null;
    if (placement === 'after_routine_intro') return intro;
    if (placement === 'before_restart') return root.querySelector('.mr-legal') || root.querySelector('.mr-steps') || intro;

    var node = intro.nextElementSibling;
    var lastProduct = null;
    var precautions = null;
    while (node) {
      if (node.classList && node.classList.contains('mr-block')) lastProduct = node;
      if (node.classList && node.classList.contains('mr-precautions')) { precautions = node; break; }
      if (node.classList && node.classList.contains('mr-steps')) break;
      node = node.nextElementSibling;
    }
    if (placement === 'after_precautions') return precautions || lastProduct || intro;
    return lastProduct || intro;
  }

  function cleanup() {
    var stack = document.querySelector('[data-mr-vnext-stack]');
    if (stack) stack.remove();
    if (window.EcloReferralVNext && window.EcloReferralVNext.remove) window.EcloReferralVNext.remove();
    var oldShare = document.querySelector('#mr-root .mr-share');
    if (oldShare) oldShare.hidden = false;
  }

  function waitForResultDom() {
    return new Promise(function (resolve, reject) {
      var deadline = Date.now() + 10000;
      (function check() {
        var root = document.getElementById('mr-root');
        var h = root && root.querySelector('.mr-h2');
        if (root && h) return resolve(root);
        if (Date.now() > deadline) return reject(new Error('result DOM timeout'));
        setTimeout(check, 80);
      })();
    });
  }

  function mount(payload) {
    lastPayload = payload || lastPayload;
    if (!lastPayload || !lastPayload.ok) return;
    cleanup();

    if (!isVNext(lastPayload)) {
      document.documentElement.removeAttribute('data-eclo-results-ui');
      return;
    }

    var debug = qs().get('vnextdebug') === '1';
    if (debug && !lastPayload.ref_code) lastPayload.ref_code = 'REF-DEMO-ECLO';
    var config = readConfig();
    applyAnalysisConfig(config);

    waitForResultDom().then(function (root) {
      var anchor = findPlacementAnchor(root, config.placement || 'after_products');
      if (!anchor) return;

      var stack = document.createElement('div');
      stack.className = 'mr-vnext-stack';
      stack.setAttribute('data-mr-vnext-stack', '');
      anchor.insertAdjacentElement('afterend', stack);

      var lang = langOf(lastPayload);
      var coupon = couponOf(lastPayload, debug);
      var hasSupplements = supplementsOf(lastPayload).length > 0;
      var blocks = Array.isArray(config.blocks) ? config.blocks : [];

      blocks.forEach(function (block) {
        if (!block || !block.type) return;
        if (block.type === 'education' && (hasSupplements || debug)) {
          stack.appendChild(educationElement(block, lang));
        }
        if (block.type === 'coupon' && coupon) {
          stack.appendChild(couponElement(block, coupon, lang, couponTimezone(lastPayload)));
        }
        if (block.type === 'referral' && (debug || moduleFlag(lastPayload, 'referral')) && window.EcloReferralVNext && lastPayload.ref_code) {
          var debugCount = qs().has('refdebug') ? qs().get('refdebug') : (debug ? '2' : null);
          window.EcloReferralVNext.render(lastPayload, { debugCount: debugCount, container: stack, config: block });
        }
      });

      if (!stack.children.length) stack.remove();
      document.documentElement.setAttribute('data-eclo-results-ui', 'vnext');
    }).catch(function (e) { console.warn('[ECLO VNext] Could not mount:', e.message); });
  }

  function refresh() { if (lastPayload) mount(lastPayload); }

  function boot() {
    var p = qs();
    var token = p.get('d');
    if (!token) return;
    fetch(apiBase() + '/api/public/diagnostic/' + encodeURIComponent(token), { headers: { accept: 'application/json' }, credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(mount)
      .catch(function (e) { console.warn('[ECLO VNext] Result contract unavailable:', e.message); });
  }

  window.EcloResultsVNext = { render: mount, boot: boot, refresh: refresh };
  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target && event.target.querySelector && event.target.querySelector('#eclo-results-vnext-config')) refresh();
  });
  document.addEventListener('shopify:section:reorder', refresh);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
